import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const skeletonVariants = cva('animate-pulse bg-muted', {
  variants: {
    variant: {
      text: 'rounded-md h-4',
      circular: 'rounded-full',
      rectangular: 'rounded-md',
    },
    size: {
      sm: 'h-2',
      md: 'h-4',
      lg: 'h-6',
    },
  },
  defaultVariants: {
    variant: 'text',
    size: 'md',
  },
});

export interface SkeletonProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof skeletonVariants> {}

function Skeleton({ className, variant, size, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        skeletonVariants({ variant, size }),
        variant === 'circular' && 'aspect-square',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton, skeletonVariants };
